export enum PointTypeEnum {
    RECEPTION_PLACE = 0,          
    CONTAINER = 1,
    INTERNAL_STORE = 2
}